import { find } from 'lodash'
import { array, boolean, date, lazy, object, string } from 'yup'

export const getUserSchema = (attributes: any) =>
  object().shape({
    id: string().nullable(),
    addresses: array().of(
      object().shape({
        formatted: string(),
        country: string(),
        locality: string(),
        postalCode: string(),
        region: string(),
        streetAddress: string(),
        type: string()
      })
    ),
    primaryAddress: string(),
    customAttributes: lazy(obj => {
      return obj
        ? object().shape(
            Object.keys(obj).reduce((final, scimAttributeName) => {
              const attribute = find(attributes, { scimAttributeName })
              let type
              switch (attribute.type) {
                case 'datetime': {
                  type = lazy(value => {
                    if (value === '') {
                      return string().trim()
                    } else {
                      return date().typeError('must be a date type')
                    }
                  })
                  break
                }
                case 'decimal': {
                  type = string()
                    .trim()
                    .matches(/(^-?(\d+\.\d+([Ee][+-]?\d+)?)$)|(^$)/, 'must be a decimal number')
                  break
                }
                case 'integer': {
                  type = string()
                    .trim()
                    .matches(/(^-?(\d+)$)|(^$)/, 'must be an integer')
                  break
                }
                case 'boolean': {
                  type = string().nullable()
                  break
                }
                case 'string': {
                  type = string().trim()
                  break
                }
                default: {
                  return final
                }
              }

              // @ts-expect-error
              final[scimAttributeName] = type
              return final
            }, {})
          )
        : object().nullable()
    }),
    displayName: string().trim(),
    name: object().shape({
      givenName: string().trim().required(),
      familyName: string().trim().required(),
      formatted: string().trim(),
      honorificPrefix: string().trim().max(8),
      honorificSuffix: string().trim().max(8),
      middleName: string().trim()
    }),
    nickName: string().trim(),
    userType: string().trim(),
    externalId: string().trim(),
    title: string().trim(),
    email: string().trim().required(),
    emails: array().of(
      object().shape({
        value: string().email().trim(),
        type: string()
      })
    ),
    primaryEmail: string(),
    timezone: string().trim(),
    active: boolean(),
    locale: string().trim(),
    phoneNumbers: array().of(
      object().shape({
        value: string().trim(),
        type: string()
      })
    ),
    primaryPhone: string(),
    photos: array().of(
      object().shape({
        value: string().trim().url(),
        type: string()
      })
    ),
    primaryPhoto: string(),
    preferredLanguage: string().trim(),
    profileUrl: string().trim().url(),
    enterpriseUser: object().shape({
      employeeNumber: string().trim(),
      costCenter: string().trim(),
      organization: string().trim(),
      department: string().trim(),
      division: string().trim(),
      manager: object().shape({
        value: string().trim(),
        displayName: string().trim()
      })
    }),
    isOrgAdmin: string().nullable()
  })
